module.exports = __webpack_public_path__ + "img/napravlen-mobile-11.53dc9df2.jpg";